/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import Header, { listImage } from '../../components/header/header'
import Layout from '../../core/layout/layout'
import HeaderOptions from '../../components/header-options/header-options'
import { listOfferItem } from '../landing/data'
import OfferItem from '../landing/components/offer-item/offer-item'
import CustomSlider from '../../components/custom-slider/custom-slider'
import Slider from "react-slick";
import SectionTC from '../../components/section-tc/section-tc'
import PaymentMethods from '../landing/components/payment-methods/payment-methods'
import styled from 'styled-components'
import FormSearchTour from '../landing/components/form-search-tour/form-search-tour'
import { listTicketItem } from './data'
import TicketItem from './components/ticket-item/ticket-item'
import { ArrowRight } from '@styled-icons/bootstrap'
import { Dollar } from '@styled-icons/boxicons-regular'
import { Flash } from '@styled-icons/entypo'
import { Sun } from '@styled-icons/evaicons-solid'
import { Moon } from '@styled-icons/heroicons-solid'
import FilterItem from './components/filter-item/filter-item'
import { device } from '../../config/theme/breakpoints'
import ButtonTC from '../../components/button-tc/button-tc'
import InputTC from '../../components/input-tc/input-tc'
import { Calendar } from '@styled-icons/feather'
import { Location } from '@styled-icons/evil'
import { Bus2 } from '@styled-icons/remix-fill'
import SelectTC from '../../components/select-tc/select-tc'
import CalendarTC from '../../components/calendar-tc/calendar-tc'

const BodyHeaderContainer = styled.div`
  color: white;
  text-align: center;
  width: 100%;
  padding: 80px 0 50px;

  > div span{
    font-size: 12px;
  }

  @media ${device.tablet}{
    padding: 120px 0 50px;
  }
`
const PreTitle = styled.h3`
  font-style: italic;
  margin-bottom: 10px;
  font-weight: lighter;
  text-transform: uppercase;
  margin: 0;
  margin-top: 20px;
`
const Title = styled.h1`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 40px;
  text-transform: uppercase;
  position: relative;
  width: fit-content;
  margin: auto;
  padding-bottom: 5px;
  margin-bottom: 40px;
`
const TitleBar = styled.div`
    width: 30px;
    height: 7px;
    background: ${p => p.theme.palette.secondary.main};
    position: absolute;
    right: 0;
    bottom: 0;
    border-radius: 6px 0 15px 6px;
    transform: skew(-30deg);
`

const FeatureCustomClass = `
    display: inherit;
`

const ContainerDestinations = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 20px;
`

const ContainerSearch = styled.div`
  width: 100%;

  @media ${device.tablet}{
    width: 25%;
  }
`
const ContainerData = styled.div`
  background: ${p => p.theme.palette.primary.main};
  border-radius: 15px;
  min-height: 100px;
  padding: 10px 12px;

  > div:nth-child(1){
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    
    > p {
      font-size: 13px;
      color: white;
      margin: 0;
    }
  }

  > div:nth-child(1) svg{
    max-width: 30px;
    color: ${p => p.theme.palette.secondary.main};
    
  }
`

const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ContainerTicket = styled.div`
  width: 100%;

  > div h3 {
    color:  ${p => p.theme.palette.primary.main};
    margin-bottom: 10px;
  }

  > div h3 svg {
    max-width: 20px;
    color:  ${p => p.theme.palette.secondary.main};
    margin: 0 10px;
  }

  @media ${device.tablet}{
    width: 70%;
  }
`
const ContainerFilter = styled.div`
  color: ${p => p.theme.palette.text.gray};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;

  @media ${device.tablet}{
    flex-direction: row;
  }
`
const ContainerFilters = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${p => p.theme.palette.text.gray};
  gap: 10px;
  flex-wrap: wrap;

  @media ${device.tablet}{
    justify-content: flex-end;
  }
`

const DestinyBar = styled.div`
  background: ${p => p.theme.palette.text.grayLight};
  border-radius: 4px 4px 15px 15px;
  position: relative;
  width: 100%;
  height: 8px;

  :after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 20%;
    height: 8px;
    border-radius: 4px 4px 15px 15px;
    background: ${p => p.theme.palette.primary.main};
  }
`
const CustomRadio = styled.div<{ active: boolean }>`
  width: 20px;
  height: 20px;
  background: transparent;
  border-radius: 50%;
  border: 2px solid ${p => p.active ? p.theme.palette.secondary.main : 'white'};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  > div {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${p => p.active ? p.theme.palette.secondary.main : 'white'};
  }
`

const CustomButton = `
  width: 100%;
  margin-top: 20px;
  padding: 10px;

  > div {
    justify-content: center;
  }
`
const ContainerNote = styled.div`
  text-align: center;

  > p{
    font-size: 12px;
    color: white;
  }
`

const ContainerOption = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin 15px auto;

  > div:nth-child(1), 
  > div:nth-child(2) {
    display: flex;
    flex-direction: row;
    gap: 10px;
    color: white;
  }
`

const listFilter = [
  {
    icon: <Dollar />,
    text: 'Más barato'
  },
  {
    icon: <Flash />,
    text: 'Más Rápido'
  },
  {
    icon: <Sun />,
    text: 'Más Temprano'
  },
  {
    icon: <Moon />,
    text: 'Más Tarde'
  },
]

const ChangeDestiny: React.FunctionComponent = () => {
  const [statusType, setStatusType] = React.useState<string>('ida_vuelta')
  const sliderOfferRef = React.useRef<Slider>(null);
  const inputOrigenRef = React.useRef<HTMLInputElement>(null)
  const inputDestinoRef = React.useRef<HTMLInputElement>(null)

  return (
    <Layout>
        <Header images={listImage}>
          <BodyHeaderContainer>
            <SectionTC>
              <PreTitle>Ciudad de</PreTitle>
              <Title>
                Chiclayo
                <TitleBar />
              </Title>
              <span>Ciudad de la Amistad</span>
            </SectionTC>
          </BodyHeaderContainer>
        </Header>
        <HeaderOptions className={FeatureCustomClass}>
          <SectionTC hidden>
            <FormSearchTour />
          </SectionTC>
        </HeaderOptions>
        <SectionTC>
            <ContainerDestinations>
                <ContainerSearch>
                  <ContainerData>
                    <div><Bus2 /> <p>Cambiar Destino</p></div>
                    <ContainerOption>
                      <div>
                        <CustomRadio active={statusType === 'ida_vuelta'} onClick={() => setStatusType('ida_vuelta')}><div /></CustomRadio>
                        <span>Ida y vuelta</span>
                      </div>
                      <div>
                        <CustomRadio active={statusType === 'ida'} onClick={() => setStatusType('ida')}><div /></CustomRadio>
                        <span>Solo ida</span>
                      </div>
                    </ContainerOption>
                    <ContainerForm>
                      <div>
                        <SelectTC
                          textHolder='Origen'
                          background='white'
                          icon={<Location />}
                          selectRef={inputOrigenRef}
                          listOptions={['Trujillo', 'Lima']}
                        />
                      </div>
                      <div>
                        <SelectTC
                          textHolder='Destino'
                          background='white'
                          icon={<Location />}
                          selectRef={inputDestinoRef}
                          listOptions={['Trujillo', 'Lima']}
                        />
                      </div>
                      <div>
                        <CalendarTC
                          icon={<Calendar />}
                          textHolder='Ida'
                          background='white'
                        />
                      </div>
                      <div>
                        <CalendarTC
                          icon={<Calendar />}
                          textHolder='Regreso'
                          background='white'
                        />
                      </div>
                      <div>
                        <ButtonTC text='Modificar Búsqueda' buttonStyle='secondary' className={CustomButton}/>
                      </div>
                      <ContainerNote><p>Nota: Si tiene algún inconveniente con su compra, comuníquese con nosotros al correo postventa@.pe en el horario de 6:30am a 10:30am de Lunes a Domingo.</p></ContainerNote>
                    </ContainerForm>
                    <p></p>
                  </ContainerData>
                </ContainerSearch>
                <ContainerTicket>
                    <div>
                      <h3>
                        Origen
                        <ArrowRight />
                        Chiclayo
                      </h3>
                      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua</p>
                    </div>
                    <DestinyBar />
                    <ContainerFilter>
                      <div>Resultados: 5</div>
                      <ContainerFilters>
                        <div>Ordenar por:</div>
                        {listFilter.map(filter => (
                          <FilterItem icon={filter.icon} text={filter.text}/>
                        ))}
                      </ContainerFilters>
                    </ContainerFilter>
                    {listTicketItem.map(ticket => (
                        <TicketItem
                            type={ticket.type}
                            inclination={ticket.inclination}
                            seatingNumber={ticket.seatingNumber}
                            price={ticket.price}
                            initTime={ticket.initTime}
                            arrivalTime={ticket.arrivalTime}
                            fromCity={ticket.fromCity}
                            toCity={ticket.toCity}
                            time={ticket.time}
                            listOptions={ticket.listOptions}
                        />
                    ))}
                </ContainerTicket>
            </ContainerDestinations>
        </SectionTC>
        <SectionTC>
          <PaymentMethods />
        </SectionTC>
        <CustomSlider
          sliderRef={sliderOfferRef}
          preTitle='Principales destinos'
          title='Y promociones'
          size={listOfferItem.length}
          withIconRight
        >
          {listOfferItem.map(offer => (
            <div key={offer.id}>
              <OfferItem
                  tour={offer.tour}
                  price={offer.price}
                  title={offer.title}
                  subTitle={offer.subTitle}
                  image={offer.image}
                />
            </div>
          ))}
        </CustomSlider>
    </Layout>
  )
}

export default ChangeDestiny